import React from 'react';
import {Control, FieldValues} from 'react-hook-form';
import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import FormCheckbox from '../FormCheckbox';

interface Props {
  control: Control<FieldValues>;
}

const SessionMediaFilter: React.FC<Props> = ({control}) => {
  const {t} = useTranslation();
  return (
    <Box>
      <Typography variant="h4" sx={{mb: 2}}>
        {t('sessionFilter.sessionMedia')}
      </Typography>
      <FormCheckbox
        control={control as unknown as Control<FieldValues>}
        name="sessionMedia.hasVideo"
        label={t('sessionFilter.hasVideo') as string}
      />
    </Box>
  );
};

export default SessionMediaFilter;
